import { LookupDto } from "../../app/model/api/types/dto";
import { Options } from "../../types";

export const getLookupValue = (
  lookupId: string | null | undefined,
  lookupData: Array<LookupDto> | undefined
): string | null | undefined => {
  return lookupData?.find((lookup) => lookup.id === lookupId)?.display;
};

const toOptions = (lookups: LookupDto[]): Options[] => {
    return lookups.sort((a, b) => ((a?.sortValue ?? 100) > (b?.sortValue ?? 100) || (a?.name ?? "") > (b?.name ?? "") ) ? 1 : -1)?.map((obj) => {
    return {
      value: obj.id ?? "",
      label: obj.display ?? "",
    };
  });
};

export { toOptions };
